import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { useNavigate } from "react-router";
import { FaEye, FaEdit } from "react-icons/fa";
import { get, patch, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import usePermission from "../../customHook/usePermission";

const Roles = () => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [isData, setIsData] = useState([]);
  const permission = usePermission();

  const handleView = async (row) => {
    try {
      if (!row?.id) return;
      let res = await get(`${URLS.ROLELIST}${row.id}/`);
      console.log("Role BYID res:", res);
      if (res?.status === "success") {
        navigate("/add-roles", { state: { data: res.data, type: "edit" } });
      }
    } catch (error) {
      console.error("Error fetching role details:", error);
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "Role",
        accessor: "name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          const getStatusClass = (status) => {
            if (status === true) return "status-active";
            if (status === false) return "status-inactive";
            return "";
          };

          return (
            <>
              {permission?.includes("CAN-STATUS-ADMIN_ROLES") && (
                <span
                  className={`status-badge ${getStatusClass(value)}`}
                  onClick={() => handleStatusChange(row?.original)}
                >
                  {value === true ? "Active" : "Inactive"}
                </span>
              )}
            </>
          );
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-EDIT-ADMIN_ROLES") && (
              <button
                className="action-btn"
                onClick={() => handleView(row?.original)}
              >
                <FaEdit />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, action];
  }, [page]);

  const fetchUserRoles = async () => {
    try {
      let res = await get(`${URLS.ROLELIST}`);
      console.log("User roles res:", res);
      if (res?.status === "success") {
        setIsData(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching user roles:", error);
    }
  };

  useEffect(() => {
    fetchUserRoles();
  }, []);

  console.log("isDataisData", isData);
  const handleStatusChange = async (row) => {
    try {
      if (!row?.id) return;
      let res = await post(`${URLS.ROLE_STATUS}`, {
        id: row?.id,
        status: !row?.status,
      });
      console.log("Role status res:", res);
      if (res?.status === "success") {
        fetchUserRoles();
      }
    } catch (error) {
      console.error("Error updating role status:", error);
    }
  };
  return (
    <>
      <PageHeader
        title="Roles"
        buttonText="+Add Role"
        buttonPath="/add-roles"
        permissionAllowed={"CAN-ADD-ADMIN_ROLES"}
      />
      <CommonTable
        columns={columns}
        data={isData || []}
        showPagination={false}
      />
    </>
  );
};

export default Roles;
